module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch1.jpg",
      "width": "4%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I look like a nerd, don’t I? Like a complete nerd,” you moan to your friend Gabe. In the mirror you see your costume and wince. “Halloween is only a few days away. I’m doomed!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You and Gabe have been best friends for two years. Gabe has long brown hair, wire-rimmed glasses — and a way of giving advice that sometimes bugs you.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You do look pretty stupid,” Gabe admits. “Where did you get that costume, anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s called Vampire in a Can,” you explain, holding up the cardboard can. “I bought it from Mr. Reuterly at Scary Stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t believe it!” Gabe slaps his forehead. “You bought a costume from the Eyeball Man? What if he took out his glass eye — right there in the store — and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("showed")]), _vm._v(" it to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He never takes out his glass eye,” you answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay, okay,” Gabe says. “But your costume is still ridiculous. It’s just a set of plastic fangs, a cheap little black cape, and a fake tattoo of fang marks for your neck. Isn’t there anything else in the can?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You pick it up and peer inside. “Hey, look!” you cry.")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Go on to "), _c('a', {
    attrs: {
      "href": "#/e9780545820660_ch002"
    }
  }, [_vm._v("PAGE 2")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48dab3f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545820660_ch001.vue
// module id = 66
// module chunks = 0